module.exports = __webpack_public_path__ + "img/2._Bergungsgruppe_B.77278305.svg";